import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './authService';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api/portfolio/`;


const initialState = {
    isLoggedIn: false,
    user: null,
    users: [],
    twoFactor: false,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    portfolioData: null, // Added portfolioData state
    data: null, // Added data state for introduction data
    error: null, // Added error state
    introData: null,   
   
};




export const loginWithCode = createAsyncThunk(
    "auth/loginWithCode",
    async ({ email, loginCode }, thunkAPI) => {
        try {
            const response = await axios.post(API_URL + `loginWithCode/${email}`, { loginCode });
            await thunkAPI.dispatch(getLoginStatus());
            return response.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const logoutUser = createAsyncThunk(
    "auth/logout",
    async ({code, email}, thunkAPI) => {
      try {
        return await authService.loginWithCode(email, code);
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message)
          || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
      }
    }
  );
  

export const sendLoginCode = createAsyncThunk(
    "auth/sendLoginCode",
    async (_, thunkAPI) => {
        try {
            return await authService.sendLoginCode();
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const getLoginStatus = createAsyncThunk('auth/getLoginStatus', async (_, thunkAPI) => {
    try {
      const response = await authService.getLoginStatus();
      return response.data; // This should be true or false indicating login status
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  });

  export const reloadPortfolioData = createAsyncThunk(
    'auth/reloadPortfolioData',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(`${API_URL}admin`);
            return response.data.data; 
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const getIntro = createAsyncThunk(
  'auth/getIntro',
  async (_, thunkAPI) => {
      try {
          const response = await axios.get(`${API_URL}get-intro`);
          console.log(response,"response");
          return response.data.intro; 
      } catch (error) {
          const message =
              (error.response && error.response.data && error.response.data.message) ||
              error.message ||
              error.toString();
          return thunkAPI.rejectWithValue(message);
      }
  }
);

export const updateUser = createAsyncThunk(
  "auth/updateUser",
  async (userData, thunkAPI) => {
    try {
      return await authService.updateUser(userData);
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message)
        || error.message || error.toString();
          return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIntroductionData = createAsyncThunk(
  'introduction/update-intro',
  async (updatePayload, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${API_URL}update-intro`, updatePayload, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
      });
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
      return rejectWithValue(message);
    }
  }
);

// Experiences

export const addExperience = createAsyncThunk(
  'experiences/add-experience',
  async (experience, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}add-experience`, experience);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const updateExperience = createAsyncThunk(
  'experiences/update-experience',
  async (experience, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${API_URL}update-experience`, experience);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const deleteExperience = createAsyncThunk(
  'experiences/delete-experience',
  async (_id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}delete-experience/${_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);
// Certificates
export const addCertificate = createAsyncThunk(
  'certificates/add-certificate',
  async (certificate, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}add-certificate`, certificate);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const updateCertificate = createAsyncThunk(
  'certificates/update-certificate',
  async (certificate, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}update-certificate`, certificate);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const deleteCertificate = createAsyncThunk(
  'certificates/delete-certificate',
  async (_id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}delete-certificate/${_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);



// Projects
export const addProject = createAsyncThunk(
  'projects/add-certificate',
  async (project, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}add-project`, project);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const updateProject = createAsyncThunk(
  'projects/update-project',
  async (project, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}update-project`, project);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const deleteProject = createAsyncThunk(
  'projects/delete-project',
  async (_id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}delete-project/${_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

export const updateAboutData = createAsyncThunk(
  'abouts/update-about',
  async (about, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${API_URL}update-about`, about);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      );
    }
  }
);

  


const rootSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
      RESET(state) {
        state.twoFactor = false;
        state.isError = false;
        state.isSuccess = false;
        state.isLoading = false;
        state.message = "";
      },
      setPortfolioData: (state, action) => {
        state.portfolioData = action.payload;
      },
      setGetIntro: (state, action) => {
        state.introData= action.payload;
    },
      ShowLoading(state) {
        state.isLoading = true;
      },
      HideLoading(state) {
        state.isLoading = false;
      },
     
    },
    extraReducers: (builder) => {
      builder
        .addCase(loginWithCode.pending, (state) => {
          state.isLoading = true; // Correct key
        })
        .addCase(loginWithCode.fulfilled, (state, action) => {
          state.isLoading = false; // Correct key
          state.isSuccess = true;
          state.isLoggedIn = true;
          state.loginStatus = true;
          toast.success('Login successful');
        })
        .addCase(loginWithCode.rejected, (state, action) => {
          state.isLoading = false; // Correct key
          state.isError = true;
          state.message = action.payload;
          toast.error("Incorrect or Expired login code, please try again");
        })




        .addCase(getLoginStatus.pending, (state) => {
          state.isLoading = true; // Correct key
        })
        .addCase(getLoginStatus.fulfilled, (state, action) => {
          state.isLoading = false; // Correct key
          state.isSuccess = true;
          state.isLoggedIn = action.payload;
        })
        .addCase(getLoginStatus.rejected, (state, action) => {
          state.isLoading = false; // Correct key
          state.isError = true;
          state.message = action.payload;
          toast.error(state.message);
        })

// update the user

        .addCase(updateUser.pending, (state) =>{
          state.isLoading = true;

         })
         .addCase(updateUser.fulfilled, (state, action) =>{
          state.isLoading = false;
          state.isSuccess= true;
          state.isLoggedIn = true;
          state.user= action.payload;
          toast.success("User Updated")
          
          
         
          
         })
         .addCase(updateUser.rejected, (state, action) =>{
          state.isLoading= false;
          state.isError= true;
          state.message= action.payload;
          console.log(action.payload) 
          toast.error(action.payload)
          toast.error("not uploaded")
          
         })

// sendlogical code


        .addCase(sendLoginCode.pending, (state) => {
          state.isLoading = true; // Correct key
        })
        .addCase(sendLoginCode.fulfilled, (state, action) => {
          state.isLoading = false; // Correct key
          state.sentCode = action.payload.code;
          state.message = action.payload;
          toast.success(state.message);
        })
        .addCase(sendLoginCode.rejected, (state, action) => {
          state.isLoading = false; // Correct key
          state.isError = true;
          state.message = action.payload;
          toast.error(action.payload);
        })







        .addCase(logoutUser.pending, (state) => {
          state.isLoading = true; // Correct key
        })
        .addCase(logoutUser.fulfilled, (state, action) => {
          state.isLoading = false; // Correct key
          state.isSuccess = true;
          state.isLoggedIn = false;
          state.user = null;
          state.message = action.payload;
          toast.success(state.message);
        })
        .addCase(logoutUser.rejected, (state, action) => {
          state.isLoading = false; // Correct key
          state.isError = true;
          state.message = action.payload;
          toast.error(action.payload);
        })


        .addCase(reloadPortfolioData.pending, (state) => {
          state.isLoading = true;
      })
      .addCase(reloadPortfolioData.fulfilled, (state, action) => {
          state.isLoading = false;
          state.portfolioData = action.payload;
      })
      .addCase(reloadPortfolioData.rejected, (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
          
      })

    .addCase(getIntro.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getIntro.fulfilled, (state, action) => {
        state.isLoading = false;
        state.introData = action.payload;
    })
    .addCase(getIntro.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        
    })



      .addCase(updateIntroductionData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateIntroductionData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        toast.success("IntroData Updated Successfully!")
      })
      .addCase(updateIntroductionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })



      .addCase(addExperience.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addExperience.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('Experience added successfully');
      })
      .addCase(addExperience.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to add experience');
      })

      .addCase(updateExperience.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateExperience.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('Experience updated successfully');
      })
      .addCase(updateExperience.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to update experience');
      })

      .addCase(deleteExperience.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteExperience.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('Experience deleted successfully');
      })
      .addCase(deleteExperience.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to delete experience');
      })




      .addCase(addCertificate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCertificate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('Certificate added successfully');
      })
      .addCase(addCertificate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to add Certificate');
      })



      .addCase(updateCertificate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCertificate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('Certificate updated successfully');
      })
      .addCase(updateCertificate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to update Certificate');
      })




      .addCase(deleteCertificate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCertificate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('Certificate deleted successfully');
      })
      .addCase(deleteCertificate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to delete Certificate');
      })
        
        


      .addCase(updateAboutData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAboutData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        toast.success('About updated successfully');
      })
      .addCase(updateAboutData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error('Failed to update About');
      });



      


        
    },
  });
  
  export const { RESET } = rootSlice.actions;
  export const setPortfolioData = createAction('auth/setPortfolioData');
  export const setGetIntro = createAction('auth/setGetIntro');

  export const ReloadData = createAction('auth/ReloadData');
  export const { ShowLoading, HideLoading, Reset } = rootSlice.actions;
  export const selectIsLoggedIn = (state) => state.root.isLoggedIn;
  export default rootSlice.reducer;
  